import logo from './logo.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
         OCS网课助手
         <br />
         专注于帮助大学生从网课中释放出来。让自己的时间把握在自己的手中。
        </p>
        <a
          className="App-link"
          href="https://docs.ocsjs.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          前往官网教程 -&gt;
        </a>
      </header>
    </div>
  );
}

export default App;
